module.exports = BD.Model.extend({
    comment: BD.belongsTo('Billy.Comment', { isParent: true }),
    owner: BD.belongsToReference()
})
